<template>
	<tabbed-page-layout class="boxes" title="Emballage" :pages="pages" />
</template>

<script>
    export default {
		props: ['pages']
    }
</script>

<style lang="scss">

</style>